import { registerGroup, registerPolygon } from '@visactor/vrender-kits';

export function loadBrushComponent() {
  registerGroup();
  registerPolygon();
}
